import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TransitPredictionsPage from './TransitPredictionsPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TransitPredictionsPage />
  </React.StrictMode>
);
